// extracted by mini-css-extract-plugin
export var centered = "_12-6";
export var flexible = "_12-5";
export var footer = "_12-k";
export var footerBorder = "_12-l";
export var header = "_12-c";
export var headerBorder = "_12-d";
export var headerDefault = "_12-g";
export var headerMedium = "_12-h";
export var headerPadding = "_12-e";
export var iconAndTitle = "_12-f";
export var large = "_12-4";
export var largePadding = "_12-a";
export var medium = "_12-3";
export var mediumPadding = "_12-9";
export var modal = "_12-0";
export var modalContainer = "_12-b";
export var noPadding = "_12-7";
export var skinny = "_12-1";
export var small = "_12-2";
export var smallPadding = "_12-8";
export var subtitle = "_12-j";
export var title = "_12-i";